import { Link } from "react-router-dom";
import { CalendarDays, ClipboardList, Users, FileText, Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="mb-4 text-xl font-semibold">ManageClean LLC</h3>
            <p className="text-gray-400">
              The all-in-one platform for janitorial business management.
            </p>
            <div className="mt-4 flex space-x-4">
              <a
                href="https://www.linkedin.com/in/wendellmacklin/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h4 className="mb-4 text-lg font-semibold">Platform Features</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link
                  to="/features/client-management"
                  className="flex items-center transition-colors hover:text-white"
                >
                  <ClipboardList className="mr-2 h-5 w-5" />
                  <span>Client Management</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/features/service-scheduling"
                  className="flex items-center transition-colors hover:text-white"
                >
                  <CalendarDays className="mr-2 h-5 w-5" />
                  <span>Service Scheduling</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/features/staff-management"
                  className="flex items-center transition-colors hover:text-white"
                >
                  <Users className="mr-2 h-5 w-5" />
                  <span>Staff Management</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/features/bids-management"
                  className="flex items-center transition-colors hover:text-white"
                >
                  <FileText className="mr-2 h-5 w-5" />
                  <span>Bids Management</span>
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-lg font-semibold">Resources & Guides</h4>
            <ul className="space-y-2.5 text-gray-400">
              <li>
                <Link to="/tools/commercial-cleaning-bid-calculator" className="font-semibold text-blue-400 hover:text-white">
                  ★ Free Bid Calculator
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="transition-colors hover:text-white">
                  Pricing Plans
                </Link>
              </li>
              <li>
                <Link to="/success-hub" className="transition-colors hover:text-white">
                  Success Hub Home
                </Link>
              </li>
              <li>
                <Link to="/success-hub/getting-started" className="transition-colors hover:text-white">
                  Bidding & Estimating
                </Link>
              </li>
              <li>
                <Link to="/success-hub/sales-lead-gen" className="transition-colors hover:text-white">
                  Sales & Lead Generation
                </Link>
              </li>
              <li>
                <Link to="/success-hub/best-practices" className="transition-colors hover:text-white">
                  Best Practices & SOPs
                </Link>
              </li>
              <li>
                <Link to="/success-hub/staff-compliance" className="transition-colors hover:text-white">
                  Staffing & Compliance
                </Link>
              </li>
              <li>
                <Link to="/success-hub/quality-retention" className="transition-colors hover:text-white">
                  Quality & Retention
                </Link>
              </li>
              <li>
                <Link to="/success-hub/faq" className="transition-colors hover:text-white">
                  Frequently Asked Questions
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-lg font-semibold">Contact Us</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center">
                <Mail className="mr-2 h-5 w-5" />
                <span>support@manageclean.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-800 pt-8">
          <div className="flex flex-col items-center justify-between md:flex-row">
            <p className="text-gray-400">
              © {new Date().getFullYear()} ManageClean LLC. All rights reserved.
            </p>
            <div className="mt-4 flex space-x-6 md:mt-0">
              <Link to="/privacy" className="text-gray-400 hover:text-white">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
